import { Directive, EventEmitter, inject, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MapMarker } from '@angular/google-maps';
import { filter, switchMap, takeUntil, tap, timer } from 'rxjs';
import AppValues from '../../../common/app.values';

@Directive({
  selector: '[markerEventDirective]',
})
export class MarkerEventDirective {
  @Output() clicked = new EventEmitter<void>();
  @Output() dblClicked = new EventEmitter<void>();

  public constructor() {
    const marker = inject(MapMarker);

    const click$ = marker.mapClick;
    const dblClick$ = marker.mapDblclick;

    const isMobile = window.innerWidth < AppValues.DEFAULT_WIDTH_FOR_MOBILE;

    click$
      .pipe(
        takeUntilDestroyed(),
        switchMap(() =>
          timer(isMobile ? 250 : 0).pipe(
            takeUntil(dblClick$),
            tap(() => this.clicked.emit()),
          ),
        ),
      )
      .subscribe();

    dblClick$
      .pipe(
        filter(() => isMobile),
        takeUntilDestroyed(),
        tap(() => this.dblClicked.emit()),
      )
      .subscribe();
  }
}
